import * as React from 'react';
import { Link, graphql } from 'gatsby';
import { Layout } from '@/components/layout/Layout';
import { SEO } from '@/components/SEO';
import { Box, Text, Anchor } from 'grommet';
import { ThemeModeContext } from '@pentester.com/grommet-theme';

const BlogPostTemplate = ({
  data: { previous, next, markdownRemark: post },
}) => {
  const { mode } = React.useContext(ThemeModeContext);

  return (
    <Layout
      background={{
        image: `url(/img/wave.webp)`,
        repeat: `no-repeat`,
        size: `contain`,
        position: `absolute`,
        opacity: mode === `light` ? 1 : `medium`,
      }}
    >
      <SEO title={`${post.frontmatter.title} | pentester.com`} />
      <Box margin={{ vertical: `xlarge`, horizontal: `large` }}>
        <Text
          size="xsmall"
          weight={500}
          color={{ light: `dark-5`, dark: `light-5` }}
          style={{ letterSpacing: `3px` }}
          margin={{ bottom: `medium` }}
        >
          {post.frontmatter.date}
        </Text>
        <Text weight={600} size="3xl" margin={{ bottom: `large` }}>
          {post.frontmatter.title}
        </Text>
        <Text
          size="medium"
          weight={500}
          color={{ light: `dark-4`, dark: `light-4` }}
          margin={{ bottom: `large` }}
        >
          {post.frontmatter.description || post.excerpt}
        </Text>
        <section
          className="article"
          dangerouslySetInnerHTML={{ __html: post.html }}
          itemProp="articleBody"
        />
        <Box
          justify="between"
          align="center"
          direction="row"
          style={{ textDecoration: `none` }}
          margin={{ vertical: `medium` }}
        >
          {previous && (
            <Anchor
              size="xsmall"
              key={previous.frontmatter.title}
              as={Link}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              to={previous.fields.slug}
              label={`← ${previous.frontmatter.title}`}
            />
          )}
          {next && (
            <Anchor
              size="xsmall"
              key={next.frontmatter.title}
              as={Link}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              to={next.fields.slug}
              label={`${next.frontmatter.title} →`}
            />
          )}
        </Box>
      </Box>
    </Layout>
  );
};
export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        featuredImage {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`;
